import { Button } from '@mui/material';
import { navigate } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import PlanItem from 'src/components/Plans/PlanItem';
import { BusinessSetupBusinessType } from 'src/shared/graphql/appsync.full';
import { PlansButtonContainer, PlansContentContainer, Soon } from 'src/styles/infoPages';

const planButtonStyles = { width: '228px', fontSize: '16px', borderRadius: '8px' };

const Plans = () => {
  const { t } = useTranslation();

  return (
    <>
      <PlansContentContainer>
        <PlanItem
          icon={BusinessSetupBusinessType.PATUR}
          title={t('businessTypes.PATUR')}
          price={'177'}
          items={[
            t('businessSolutions.incomeDocs'),
            t('businessSolutions.expenses'),
            t('businessSolutions.annualReport'),
            t('businessSolutions.biMonthlyReportIncomeTax'),
            t('businessSolutions.taxCoordination'),
            t('businessSolutions.personalSupport'),
          ]}
        />
        <PlansButtonContainer>
          <Button
            variant="contained"
            sx={planButtonStyles}
            onClick={() => {
              navigate('/signup');
            }}>
            {t('solutions.signup')}
          </Button>
        </PlansButtonContainer>
      </PlansContentContainer>
      <PlansContentContainer>
        <PlanItem
          icon={BusinessSetupBusinessType.MURSHE}
          title={t('businessTypes.MURSHE')}
          price={'400'}
          vat
          items={[
            t('businessSolutions.incomeDocs'),
            t('businessSolutions.expenses'),
            t('businessSolutions.annualReport'),
            t('businessSolutions.biMonthlyReportVAT'),
            t('businessSolutions.biMonthlyReportIncomeTax'),
            t('businessSolutions.taxCoordination'),
            t('businessSolutions.personalSupport'),
          ]}
        />

        <PlansButtonContainer>
          <Button
            variant="contained"
            sx={planButtonStyles}
            onClick={() => {
              navigate('/signup');
            }}>
            {t('solutions.signup')}
          </Button>
        </PlansButtonContainer>
      </PlansContentContainer>
      <PlansContentContainer>
        <Soon>בקרוב</Soon>
        <PlanItem
          icon={BusinessSetupBusinessType.LTD}
          title={t('businessTypes.LTD')}
          price={'1500'}
          vat
          items={[
            t('businessSolutions.employees'),
            t('businessSolutions.incomeDocs'),
            t('businessSolutions.expenses'),
            t('businessSolutions.annualReport'),
            t('businessSolutions.biMonthlyReportVAT'),
            t('businessSolutions.biMonthlyReportIncomeTax'),
            t('businessSolutions.taxCoordination'),
            t('businessSolutions.personalSupport'),
          ]}
        />
        <PlansButtonContainer>
          <Button
            disabled
            variant="contained"
            sx={planButtonStyles}
            onClick={() => {
              navigate('/signup');
            }}>
            {t('solutions.signup')}
          </Button>
        </PlansButtonContainer>
      </PlansContentContainer>
    </>
  );
};

export default Plans;
